// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"7b765f85","200":"46fea938","287":"4a6feb74","290":"71228511","550":"d3ca9927","608":"ca0a4314","841":"c553ba34"}[chunkId] + ".chunk.js";
};